
import { defineComponent } from "vue";
import AppHeader from "../common/AppHeader.vue";
import AppSidebar from "../common/AppSidebar.vue";
import { mapGetters, mapMutations } from "vuex";
import LogoutTimerModal from "../LogoutTimerModal.vue";
import common from "@/config/common";

export default defineComponent({
  name: "DashboardLayout",
  components: { AppHeader, AppSidebar, LogoutTimerModal },
  data() {
    return { logoutTimer: 0 };
  },
  computed: {
    ...mapGetters(["getLogoutModal", "getLogoutTimer", "getClearTheInterval"]),
  },
  watch: {
    getLogoutTimer() {
      clearTimeout(this.logoutTimer);
      this.setLogoutTimer();
    },
    getClearTheInterval() {
      clearTimeout(this.logoutTimer);
    },
  },
  created() {
    this.setLogoutModal(false);
    this.setLogoutTimer();
    document.addEventListener("mousemove", this.resetIdleTimer);
    document.addEventListener("keydown", this.resetIdleTimer);
  },
  methods: {
    ...mapMutations(["setLogoutModal"]),
    setLogoutTimer() {
      this.logoutTimer = window.setTimeout(() => {
        if (!this.getLogoutModal) {
          this.setLogoutModal(true);
        }
      }, common.logoutModalInterval * 60000);
    },
    resetIdleTimer() {
      if (!this.getLogoutModal) {
        clearTimeout(this.logoutTimer);
        this.setLogoutTimer();
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener("mousemove", this.resetIdleTimer);
    document.removeEventListener("keydown", this.resetIdleTimer);
  },
});
